
import { v4 as uuidv4 } from "uuid";
import * as helpers from './shootingProgramHelpers.js';

const SeriesEdit = {
  name: "SeriesEdit",
  methods: {
    onAddSeries() {
      this.series.push({
        id: uuidv4(),
        name: {
          defaultValue: {
            value: "New series"
          },
          profileValues: [],
        },
        type: "SIGHTING",
        markingType: "OPEN",
        shotCount: 0,
        procedures: [
          {
            id: uuidv4(),
            executionCount: 1,
            procedureSteps: [],
          },
        ],
      });
    },
    onDeleteSeries(id) {
      this.series = this.series.filter((serie) => serie.id !== id);
    },
  },
  
  data() {
   return {
     //series: [],
    timeRule: [(v) => helpers.validateTimeInput(v) || 'Incorrect time format - (HH:MM:SS)'],
   };
  },
  props: {
    series: {
      type: Array,
      required: true
    }
  },
  template: `
    <div class="series-edit">
 
        <v-row>
            <v-col cols="12">
            <v-toolbar color="grey lighten-3">
                <v-toolbar-title>Series</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn small fab color="primary" @click="onAddSeries">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-toolbar>

                <v-expansion-panels focusable>
                <v-expansion-panel v-for="serie in series" :key="serie.id">
                    <v-expansion-panel-header color="grey lighten-5">
                    <template v-slot:default="{ open }">
                        <v-fade-transition leave-absolute>
                        <v-row no-gutters>
                            <v-col cols="5">
                            <span v-if="open" key="0">
                                {{ serie.name.defaultValue.value }}
                            </span>
                            <span v-else key="1">
                                {{ serie.name.defaultValue.value }}
                            </span>
                            </v-col>
                            <v-spacer> </v-spacer>

                            <v-col cols="2">
                            <span v-if="serie.shotCount == 0"> ∞ </span>
                            <span v-else>
                                {{ serie.shotCount }}
                            </span>
                            </v-col>

                            <v-col cols="2">
                            <v-chip
                                v-if="serie.type == 'MATCH'"
                                small
                                color="primary"
                            >
                                MATCH
                            </v-chip>
                            <v-chip
                                v-if="serie.type == 'SIGHTING'"
                                small
                                color="inverted"
                            >
                                SIGHTING
                            </v-chip>
                            </v-col>

                            <v-col cols="2">
                            <v-chip
                                v-if="serie.markingType == 'OPEN'"
                                small
                                color="primary"
                            >
                                OPEN
                            </v-chip>
                            <v-chip
                                v-if="serie.markingType == 'CLOSED'"
                                small
                                color="inverted"
                            >
                                CLOSED
                            </v-chip>
                            </v-col>
                            <v-col cols="1">
                            <v-btn icon>
                                <v-icon @click="onDeleteSeries(serie.id)"
                                >mdi-close-thick</v-icon
                                >
                            </v-btn>
                            </v-col>
                        </v-row>
                        </v-fade-transition>
                    </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12">
                        <v-text-field
                            v-model="serie.name.defaultValue.value"
                            label="Name"
                            placeholder="Series name"
                        ></v-text-field>

                        <v-row>
                            <v-col cols="4">
                            <p>Series type</p>
                            <v-radio-group v-model="serie.type" mandatory>
                                <v-radio label="Sighting" value="SIGHTING"></v-radio>
                                <v-radio label="Match" value="MATCH"></v-radio>
                            </v-radio-group>
                            </v-col>
                            <v-col cols="4">
                            <p>Marking</p>
                            <v-radio-group v-model="serie.markingType" mandatory>
                                <v-radio label="Open" value="OPEN"></v-radio>
                                <v-radio label="Closed" value="CLOSED"></v-radio>
                            </v-radio-group>
                            </v-col>
                            <v-col cols="4">
                            <v-text-field
                                v-model.number="serie.shotCount"
                                type="number"
                                label="Shot count"
                            ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                            <v-radio-group v-model="serie.timeMode" mandatory>
                                <v-radio
                                label="Continue from previous series time"
                                value="CONTINUE"
                                ></v-radio>
                                <v-radio label="New time" value="NEW"></v-radio>
                            </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row v-if="serie.timeMode == 'NEW'">
                            <v-col cols="2">
                            <v-text-field
                                v-model="serie.preparationTime"
                                label="Preparation time"
                                placeholder="Time"
                                :rules="timeRule"
                            ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                            <v-text-field
                                v-model="serie.countdownTime"
                                label="Countdown time"
                                placeholder="Time"
                                :rules="timeRule"
                            ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                            <v-text-field
                                v-model="serie.scoringTime"
                                label="Scoring time"
                                placeholder="Time"
                                :rules="timeRule"
                            ></v-text-field>
                            </v-col>
                        </v-row>
                        </v-col>
                    </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
     </div>
  `
};

export default SeriesEdit;